import React, {useEffect, useState} from 'react';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SupportIcon from '@mui/icons-material/Support';
import {Link} from 'react-router-dom';

import Alert, {useAlert} from 'components/snacks/Alert';

import Loading from 'layout/Loading';
import {axiosInstance} from 'api/Api';
import {indexHeader} from "utils/DataBase";
import {StatusBoxes} from "components/StatusBoxes";

const Profile = () => {
    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState([0, 0, 0]);
    const [tab, setTab] = useState('real');
    const [provinceList, setProvinceList] = useState([]);
    const [cityList, setCityList] = useState([]);
    // ------
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [province, setProvince] = useState('1');
    const [city, setCity] = useState('1');
    const [postalCode, setPostalCode] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyNationalId, setCompanyNationalId] = useState('');
    const [economicalNumber, setEconomicalNumber] = useState('');
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [technicalPerson, setTechnicalPerson] = useState('');
    const [technicalPersonMobile, setTechnicalPersonMobile] = useState('');
    const [address, setAddress] = useState('');
    const [lastUpdate, setLastUpdate] = useState('');

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const submitForm = (e) => {
        e.preventDefault();
        let error_message = '';
        let char = /^[\u0600-\u06FF\s]+$/;
        if (nationalCode.length < 10) {
            error_message = 'لطفا کد ملی را درست وارد کنید.';
        } else if (phone.length < 10) {
            error_message = 'لطفا شماره تماس را درست وارد کنید.';
        } else if (!email) {
            error_message = 'لطفا ایمیل را وارد کنید.';
        } else if (postalCode.length > 0 && postalCode.length < 10) {
            error_message = 'لطفا کد پستی را درست وارد کنید.';
        } else if (tab === 'legal' && companyName.length < 2) {
            error_message = 'لطفا نام شرکت را درست وارد کنید.';
        } else if (tab === 'legal' && companyNationalId.length < 2) {
            error_message = 'لطفا شناسه ملی را درست وارد کنید.';
        } else if (tab === 'legal' && economicalNumber.length < 2) {
            error_message = 'لطفا شماره اقتصادی را درست وارد کنید.';
        } else if (tab === 'legal' && registrationNumber.length < 2) {
            error_message = 'لطفا شماره ثبت را درست وارد کنید.';
        }
        if (error_message !== '') {
            alertStore.AddAlert({
                key: 'validation',
                message: error_message,
                severity: 'error',
                auto_hide: true
            });
        } else {
            setLoading(true);
            let formData = new FormData();
            formData.append('nid', nationalCode);
            formData.append('phone', phone);
            formData.append('email', email);
            formData.append('state', province);
            formData.append('city', city);
            formData.append('post_code', postalCode);
            formData.append('address', address);
            if (tab === 'legal') {
                formData.append('company', companyName);
                formData.append('nid_num', companyNationalId);
                formData.append('economic_num', economicalNumber);
                formData.append('technical_person', technicalPerson);
                formData.append('technical_person_mobile', technicalPersonMobile);
                formData.append('register_num', registrationNumber);
                formData.append('customer_type', '2');
            } else {
                formData.append('customer_type', '1');
            }
            axiosInstance()
                .post('edit-profile', formData)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === 200) {
                        alertStore.AddAlert({
                            key: 'success',
                            message: res.data.msg,
                            severity: 'success',
                            auto_hide: true
                        });
                        window.location.reload();
                    } else {
                        alertStore.AddAlert({
                            key: '400',
                            message: res.data.msg,
                            severity: 'error',
                            auto_hide: true
                        });
                    }
                });
        }
    };

    const getUserInfo = () => {
        setLoading(true);
        axiosInstance()
            .get('get-user-info')
            .then((res) => {
                const result = res.data;
                setNumber(() => [
                    result.ticket_count,
                    result.service_count,
                    result.factor_count
                ]);
                setAddress(result.user_info.address);
                setCity(result.user_info.city_id);
                setCompanyName(result.user_info.company);
                setEconomicalNumber(result.user_info.economic_num);
                setEmail(result.user_info.email);
                setFirstName(result.user_info.first_name);
                setLastName(result.user_info.last_name);
                setPhone(result.user_info.mobile);
                setNationalCode(result.user_info.nid);
                setCompanyNationalId(result.user_info.nid_num);
                // setPhone(result.user_info.phone);
                setPostalCode(result.user_info.post_code);
                setRegistrationNumber(result.user_info.register_num);
                setTechnicalPerson(result.user_info.technical_person);
                setTechnicalPersonMobile(result.user_info.technical_person_mobile);
                setProvince(result.user_info.state_id);
                setLastUpdate(result.user_info.updated_at);
                if (result.user_info.customer_type === 1) {
                    setTab('real');
                } else {
                    setTab('legal');
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const getProvinces = () => {
        axiosInstance()
            .get('get-province-list')
            .then((res) => {
                setProvinceList(res.data.provinces);
            });
    };

    const getCities = (provinceId) => {
        setCityList([]);
        axiosInstance()
            .get(`get-city-list?province_id=${provinceId}`)
            .then((res) => {
                setCityList(res.data.cities);
            });
    };

    // EFFECTS
    useEffect(() => {
        setLoading(false);
        getProvinces();
        getUserInfo();
    }, []);

    useEffect(() => {
        getCities(province);
    }, [province]);

    // JSX
    return (
        <>
            {loading ? (
                <Loading/>
            ) : (
                <>
                    {/* *********************** DETAIL *********************** */}
                    <section className="bg-white rounded-lg normal-shadow p-5">
                        <div className="row justify-content-between align-items-center">
                            {/* *********************** NAME *********************** */}
                            <div className="col-12 col-md-6 col-lg-4">
                                <h1 className="m-0">
                                    {firstName} {lastName}
                                </h1>
                                <p className="bg-light-success fw-bolder p-3 mt-5 d-flex justify-content-between align-items-center">
                                    <span>آخرین بروزرسانی : </span>
                                    <span>{lastUpdate}</span>
                                </p>
                            </div>
                            {/* *********************** SERVICES *********************** */}
                            <div className="col-12 col-md-6 col-lg-8 mt-3 mt-md-0">
                                <div className="row">
                                    {indexHeader.map((item, index) => (
                                        <div
                                            className={`col-lg-4`}
                                            key={index}
                                        >
                                            <StatusBoxes index={index} item={item} number={number}/>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* *********************** FORM *********************** */}
                    <section className="bg-white rounded-lg normal-shadow p-5 mt-10 mb-2">
                        {/* *********************** FORM TAB *********************** */}
                        <div className="row align-items-center justify-content-between">
                            <div className="col-12 col-md-8">
                                <p className="m-0 f-13">ویرایش اطلاعات کاربری</p>
                            </div>
                            {/*<div className="col-6 col-md-2 col-xl-2 mt-3 mt-md-0">*/}
                            {/*  <button*/}
                            {/*    onClick={() => setTab('real')}*/}
                            {/*    className={`btn w-100 btn-outline category-btn-profile ${*/}
                            {/*      tab === 'real' ? 'active' : ''*/}
                            {/*    }`}*/}
                            {/*  >*/}
                            {/*    حقیقی*/}
                            {/*  </button>*/}
                            {/*</div>*/}
                            {/*<div className="col-6 col-md-2 col-xl-2 mt-3 mt-md-0">*/}
                            {/*  <button*/}
                            {/*    onClick={() => setTab('legal')}*/}
                            {/*    className={`btn w-100 btn-outline category-btn-profile ${*/}
                            {/*      tab === 'legal' ? 'active' : ''*/}
                            {/*    }`}*/}
                            {/*  >*/}
                            {/*    حقوقی*/}
                            {/*  </button>*/}
                            {/*</div>*/}
                        </div>
                        <hr/>
                        {/* *********************** FORM INPUT *********************** */}
                        <form
                            method={'post'}
                            onSubmit={submitForm}
                            className="row align-items-center"
                        >
                            {/* *********************** FORM INPUT *********************** */}
                            <div className="col-12 col-md-8">
                                <div className="row">
                                    {/* **************** FORM USER TYPE **************** */}
                                    <div className="col-12 mt-5">
                                        <div className="d-flex fv-row mb-4 fv-plugins-icon-container">
                                            <label className=" form-check-inline me-3" onClick={() => {
                                                setTab('real');
                                            }}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="toc"
                                                    value="real"
                                                    onChange={() => {
                                                        setTab('real');
                                                    }}
                                                    checked={tab === 'real'}
                                                />
                                                <span className="ms-2 cursor-pointer">حقیقی</span>
                                            </label>
                                            <label className=" form-check-inline me-3" onClick={() => {
                                                setTab('legal');
                                            }}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="toc"
                                                    value="2"
                                                    onChange={() => {
                                                        setTab('legal');
                                                    }}
                                                    checked={tab === 'legal'}
                                                />
                                                <span className="ms-2 cursor-pointer">حقوقی</span>
                                            </label>
                                        </div>
                                    </div>
                                    {/* *********************** NATIONAL CODE *********************** */}
                                    <div className="col-12 col-md-6 col-xl-4 mt-5">
                                        <label htmlFor="profile_national_code">کد ملی *</label>
                                        <input
                                            type="text"
                                            className="form-control login-input"
                                            id="profile_national_code"
                                            value={nationalCode}
                                            onChange={(e) => setNationalCode(e.target.value)}
                                            required
                                        />
                                    </div>
                                    {/* *********************** PHONE *********************** */}
                                    <div className="col-12 col-md-6 col-xl-4 mt-5">
                                        <label htmlFor="profile_phone">تلفن تماس *</label>
                                        <input
                                            type="tel"
                                            className="form-control login-input"
                                            id="profile_phone"
                                            value={phone}
                                            disabled={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            required
                                        />
                                    </div>
                                    {/* *********************** EMAIL *********************** */}
                                    <div className="col-12 col-md-6 col-xl-4 mt-5">
                                        <label htmlFor="profile_email">ایمیل *</label>
                                        <input
                                            type="email"
                                            className="form-control login-input"
                                            id="profile_email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    {/* *********************** PROVINCE *********************** */}
                                    <div className="col-12 col-md-6 col-xl-4 mt-5">
                                        <label htmlFor="profile_province">استان</label>
                                        <select
                                            name="profile_province"
                                            id="profile_province"
                                            className="form-select login-input"
                                            defaultValue={province}
                                            onChange={(e) => setProvince(e.target.value)}
                                        >
                                            {provinceList && (
                                                <>
                                                    {provinceList.map((prov) => (
                                                        <option
                                                            key={prov.id}
                                                            value={prov.id}
                                                            selected={province === prov.id}
                                                        >
                                                            {prov.name}
                                                        </option>
                                                    ))}
                                                </>
                                            )}
                                        </select>
                                    </div>
                                    {/* *********************** CITY *********************** */}
                                    <div className="col-12 col-md-6 col-xl-4 mt-5">
                                        <label htmlFor="profile_city">شهر</label>
                                        <select
                                            name="profile_city"
                                            id="profile_city"
                                            className="form-select login-input"
                                            onChange={(e) => setCity(e.target.value)}
                                        >
                                            {cityList && (
                                                <>
                                                    {cityList.map((cit) => (
                                                        <option
                                                            key={cit.id}
                                                            value={cit.id}
                                                            selected={city === cit.id}
                                                        >
                                                            {cit.name}
                                                        </option>
                                                    ))}
                                                </>
                                            )}
                                        </select>
                                    </div>
                                    {/* *********************** POSTAL CODE *********************** */}
                                    <div className="col-12 col-md-6 col-xl-4 mt-5">
                                        <label htmlFor="profile_postal_code">کد پستی</label>
                                        <input
                                            type="tel"
                                            className="form-control login-input"
                                            id="profile_postal_code"
                                            value={postalCode}
                                            onChange={(e) => setPostalCode(e.target.value)}
                                        />
                                    </div>
                                    {/* *********************** LEGAL *********************** */}
                                    {tab === 'legal' && (
                                        <>
                                            {/* *********************** COMPANY NATIONAL CODE *********************** */}
                                            <div className="col-12 col-md-6 col-xl-4 mt-5">
                                                <label htmlFor="profile_company_name">نام شرکت *</label>
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    id="profile_company_name"
                                                    value={companyName}
                                                    onChange={(e) => setCompanyName(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            {/* *********************** COMPANY NATIONAL CODE *********************** */}
                                            <div className="col-12 col-md-6 col-xl-4 mt-5">
                                                <label htmlFor="profile_company_national_code">
                                                    شناسه ملی *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    id="profile_company_national_code"
                                                    value={companyNationalId}
                                                    onChange={(e) => setCompanyNationalId(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            {/* *********************** COMPANY NATIONAL CODE *********************** */}
                                            <div className="col-12 col-md-6 col-xl-4 mt-5">
                                                <label htmlFor="profile_economicalNumber">
                                                    شماره اقتصادی *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    id="profile_economicalNumber"
                                                    value={economicalNumber}
                                                    onChange={(e) => setEconomicalNumber(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            {/* *********************** COMPANY NATIONAL CODE *********************** */}
                                            <div className="col-12 col-md-6 col-xl-4 mt-5">
                                                <label htmlFor="profile_registrationNumber">
                                                    شماره ثبت *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    id="profile_registrationNumber"
                                                    value={registrationNumber}
                                                    onChange={(e) =>
                                                        setRegistrationNumber(e.target.value)
                                                    }
                                                    required
                                                />
                                            </div>
                                            {/* *********************** TECHNICAL PERSON *********************** */}
                                            <div className="col-12 col-md-6 col-xl-4 mt-5">
                                                <label htmlFor="profile_technical_person">
                                                    نام رابط فنی
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    id="profile_technical_person"
                                                    value={technicalPerson}
                                                    onChange={(e) =>
                                                        setTechnicalPerson(e.target.value)
                                                    }
                                                />
                                            </div>
                                            {/* *********************** TECHNICAL PERSON MOBILE *********************** */}
                                            <div className="col-12 col-md-6 col-xl-4 mt-5">
                                                <label htmlFor="profile_technical_person_mobile">
                                                    شماره همراه رابط فنی
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    id="profile_technical_person_mobile"
                                                    value={technicalPersonMobile}
                                                    onChange={(e) =>
                                                        setTechnicalPersonMobile(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                    {/* *********************** ADDRESS *********************** */}
                                    <div
                                        className={`col-12 ${
                                            tab === 'legal' ? 'col-xl-8' : ''
                                        } mt-5`}
                                    >
                                        <label htmlFor="profile_address">آدرس</label>
                                        <textarea
                                            className="form-control login-input"
                                            id="profile_address"
                                            onChange={(e) => setAddress(e.target.value)}
                                            rows={5}
                                            defaultValue={address}
                                        ></textarea>
                                    </div>
                                    {/* *********************** SUBMIT *********************** */}
                                    <div className="col-12 mt-5">
                                        <button type="submit" className="btn btn-success">
                                            ثبت اطلاعات
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* *********************** FORM IMAGE *********************** */}
                            <div className="col-12 col-md-4">
                                <img
                                    src="/assets/media/ezgif.com-gif-maker.jpg"
                                    alt="form"
                                    className="img-fluid"
                                />
                            </div>
                        </form>
                    </section>
                </>
            )}
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </>
    );
};

export default Profile;
